// Assets cars
import car1Image from '../../assets/cars/subaru.png';
import car2Image from '../../assets/cars/bmwX5.png';
import car3Image from '../../assets/cars/nissanGTR.png';
import car4Image from '../../assets/cars/nissanSKYLine.png';
// Assets pedals
import left1Image from '../../assets/nav/1l.png';
import right1Image from '../../assets/nav/1r.png';
import gaz1Image from '../../assets/nav/1gaz.png';

import left2Image from '../../assets/nav/2l.png';
import right2Image from '../../assets/nav/2r.png';
import gaz2Image from '../../assets/nav/2gaz.png';

import left3Image from '../../assets/nav/3l.png';
import right3Image from '../../assets/nav/3r.png';
import gaz3Image from '../../assets/nav/3gaz.png';

import left4Image from '../../assets/nav/4l.png';
import right4Image from '../../assets/nav/4r.png';
import gaz4Image from '../../assets/nav/4gaz.png';

import left5Image from '../../assets/nav/5l.png';
import right5Image from '../../assets/nav/5r.png';
import gaz5Image from '../../assets/nav/5gaz.png';

import left6Image from '../../assets/nav/6l.png';
import right6Image from '../../assets/nav/6r.png';
import gaz6Image from '../../assets/nav/6gaz.png';
// Logo cars 
import { DodgeIcon } from '../../components/Icons/Icons';
import { SiBmw, SiMclaren, SiOpel, SiChevrolet, SiAudi, SiFord, SiNissan, SiMercedes, SiPorsche, SiLamborghini } from 'react-icons/si';
import { TbBrandToyota, TbMilitaryAward } from 'react-icons/tb';

export const top = '-140px';
export const leftDef = '-185px';
export const leftTrans = '-215px';

export const cars = [
    {
      name: 'BMW M4',
      price: 0,
      icon: SiBmw,
      maxSpeed: 292,
      model: car1Image,
      weight: 800,
      modelPath: '/models/2021_bmw_m4_competition-min-2.glb',
      scale: 0.74,
      position: [0, 3.5, -5],
      target3: -1.9,
      view: {
        position: [2, 3.5, 5],
        target3: 2,
        top,
        left: leftDef
      }
    },
    {
      name: 'Dodge Challenger',
      price: 0,
      icon: DodgeIcon,
      maxSpeed: 290,
      model: car2Image,
      weight: 1200,
      modelPath: '/models/free__dodge_challenger_srt_v2-min.glb',
      scale: 1.05,
      position: [0, 3.5, -5],
      target3: -1.98,
      view: {
        position: [-2, 3.5, 5],
        target3: 2.02,
        top,
        left: leftDef
      }
    },
    {
      name: 'Mustang GT',
      price: 0,
      icon: SiFord,
      maxSpeed: 244,
      model: car2Image,
      weight: 1200,
      modelPath: '/models/2018_ford_mustang_gt_v2.glb',
      scale: 108,
      position: [0, 3.5, -5],
      target3: -1.9,
      view: {
        position: [2, 3.5, 5],
        target3: 2,
        top,
        left: leftDef
      }
    },
    {
      name: 'AUDI R8',
      price: 350,
      icon: SiAudi,
      maxSpeed: 292,
      model: car1Image,
      weight: 800,
      modelPath: '/models/audi_r8_3d_model_2.glb',
      scale: 1.02,
      position: [0, 3, -5],
      target3: -2.6,
      view: {
        position: [-2, 3.5, 5],
        target3: 1.2,
        top: '-230px',
        left: leftDef
      }
    },
    {
      name: 'Nissan GTR',
      price: 350,
      icon: SiNissan,
      maxSpeed: 304,
      model: car3Image,
      weight: 900,
      modelPath: '/models/nissan_gt-r.glb',
      scale: 0.026,
      position: [0, 3, -5],
      target3: -2.3,
      view: {
        position: [-2, 2, 6.7],
        target3: 2.5,
        top: '-250px',
        left: leftDef
      }
    },
    {
      name: 'Toyota Supra MK4',
      price: 350,
      icon: TbBrandToyota,
      maxSpeed: 301,
      model: car3Image,
      weight: 900,
      modelPath: '/models/toyota_supra_mk4_v2.glb',
      scale: 1.1,
      position: [0, 3.5, -5],
      target3: -1.8,
      view: {
        position: [2, 3.5, 5],
        target3: 2,
        top,
        left: leftDef
      }
    },
    {
      name: 'Lamborghini Huracan', 
      price: 500,
      icon: SiLamborghini,
      maxSpeed: 492,
      model: car1Image,
      weight: 800,
      modelPath: '/models/lamborghini_huracan_twin_turbo_lost_v2.glb',
      scale: 1.13,
      position: [0, 3.5, -5],
      target3: -1.8,
      view: {
        position: [-2, 3.2, 5],
        target3: 1,
        top: '-200px',
        left: leftDef
      }
    },
    {
      name: 'Chevrolet Camaro',
      price: 350,
      icon: SiChevrolet,
      maxSpeed: 290,
      model: car1Image,
      weight: 800,
      modelPath: '/models/2012_chevrolet_camaro_zl1_v2.glb',
      scale: 105,
      position: [0, 3.5, -5],
      target3: -1.9,
      view: {
        position: [2, 3.5, 5],
        target3: 2,
        top,
        left: leftDef
      }
    },
    {
      name: 'Porsche',
      price: 350,
      icon: SiPorsche,
      maxSpeed: 302,
      model: car1Image,
      weight: 900,
      modelPath: '/models/porshe_v2.glb',
      scale: 1.04,
      position: [0, 3.5, -5],
      target3: -1.9,
      view: {
        position: [-2, 3.5, 5],
        target3: 1.8,
        top: '-160px',
        left: leftDef
      }
    },
    {
      name: 'Mercedes G-class',
      price: 500,
      icon: SiMercedes,
      maxSpeed: 234,
      model: car4Image,
      weight: 1300,
      modelPath: '/models/mercedes_benz_g-class_w263_v2.glb',
      scale: 1.67,
      position: [0, 4.5, -5],
      target3: -1.4,
      view: {
        position: [-2, 4.5, 6],
        target3: 2.2,
        top: '-90px',
        left: leftDef
      }
    },
    /*{
      name: 'BMW E34',
      price: 200,
      icon: SiBmw,
      maxSpeed: 322,
      model: car1Image,
      weight: 2000,
      modelPath: '/models/1987_bmw_e34_lp_v2.glb',
      scale: 1,
      position: [0, 3.5, -5],
      target3: -1.8,
      view: {
        position: [2, 3.5, 5],
        target3: 2,
        top,
        left: leftDef
      }
    },*/
    {
      name: 'Opel Astra VXR',
      price: 350,
      icon: SiOpel,
      maxSpeed: 212,
      model: car1Image,
      weight: 810,
      modelPath: '/models/vauxhall_astra_vxr_v2.glb',
      scale: 1,
      position: [0, 3.5, -5],
      target3: -1.9,
      view: {
        position: [-2, 3.5, 5],
        target3: 2.02,
        top,
        left: leftDef
      }
    },
    {
      name: 'McLaren MP45',
      price: 600,
      icon: SiMclaren,
      maxSpeed: 413,
      model: car1Image,
      weight: 510,
      modelPath: '/models/mclaren_mp45__formula_1.glb',
      scale: 0.66,
      position: [0, 3.5, -5],
      target3: -1.9,
      view: {
        position: [2, 3.5, 5],
        target3: 2.02,
        top,
        left: leftDef
      }
    }
];

export const colors = [
    { price: 0, color: '#c41111' },
    { price: 0, color: '#e8e8e8' },
    { price: 0, color: '#373b50' },
    { price: 70, color: '#482b8b' },
    { price: 70, color: '#3a52a5' },
    { price: 70, color: '#3aa597' },
    { price: 70, color: '#b6bb38' }, 
    { price: 70, color: '#757575' },
    { price: 70, color: '#9C27B0' },
    { price: 70, color: '#FF9800' },
    { price: 70, color: '#85fffa' },
    { price: 70, color: '#ed2560' },
    { price: 70, color: '#0397fc' },
    { price: 70, color: '#1e5a72' },
    { price: 70, color: '#891738' },
    { price: 70, color: '#979797' },
    { price: 70, color: '#262369' },
    { price: 70, color: '#70b3ee' },
    { price: 70, color: '#8ecf12' },
    { price: 70, color: '#1e1f23' },
    { price: 70, color: '#ccc3a8' },
    { price: 70, color: '#bca8cc' },
    { price: 70, color: '#cca8b3' },
    { price: 70, color: '#a8b8cc' }
];

export const civilianCars = [
  cars[1],  // Dodge
  cars[2],  // Mustang
  cars[9],  // Mercedes G-class
  cars[10], // Opel Astra VXR
];

export const pedals = [
    {
      name: 'Neon',
      price: 0,
      model: {
        l: left3Image,
        r: right3Image,
        g: gaz3Image
      },
    },
    {
      name: 'Minimalism',
      price: 105,
      model: {
        l: left1Image,
        r: right1Image,
        g: gaz1Image
      },
    },
    {
      name: 'Metallic',
      price: 110,
      model: {
        l: left2Image,
        r: right2Image,
        g: gaz2Image
      },
    },
    {
      name: 'Classic',
      price: 115,
      model: {
        l: left4Image,
        r: right4Image,
        g: gaz4Image
      },
    },
    {
      name: 'Inferno',
      price: 120,
      model: {
        l: left5Image,
        r: right5Image,
        g: gaz5Image
      },
    },
    {
      name: 'Vibe',
      price: 125,
      model: {
        l: left6Image,
        r: right6Image,
        g: gaz6Image
      },
    }
];